import { Dropdown, DropdownItem } from "nectar-ui";
import PropTypes from "prop-types";
import React from "react";

import { LAWSUIT_COUNTER_FILTERS } from "../../../utils/constants/dashboard/dashboardModuleConstants";
import DashboardFilterButton from "../../DashboardFilterButton";

interface DashboardChartLawsuitCountTypeFilterProps {
  selectedCountType: string;
  setCountTypeFunction: (arg0: string) => void;
}

const DashboardChartLawsuitCountTypeFilter = ({
  selectedCountType,
  setCountTypeFunction
}: DashboardChartLawsuitCountTypeFilterProps) => {
  const rangeDropdownOptions = Object.keys(LAWSUIT_COUNTER_FILTERS).map((countType) => (
    <DropdownItem
      key={countType}
      onClick={() => setCountTypeFunction(countType)}
      active={countType === selectedCountType}
    >
      {LAWSUIT_COUNTER_FILTERS[countType as keyof typeof LAWSUIT_COUNTER_FILTERS].label}
    </DropdownItem>
  ));

  return (
    <Dropdown
      position="left"
      action={<DashboardFilterButton>{LAWSUIT_COUNTER_FILTERS[selectedCountType as keyof typeof LAWSUIT_COUNTER_FILTERS].label}</DashboardFilterButton>}
      options={rangeDropdownOptions}
    />
  );
};

DashboardChartLawsuitCountTypeFilter.propTypes = {
  selectedCountType: PropTypes.string.isRequired,
  setCountTypeFunction: PropTypes.func.isRequired
};

export default DashboardChartLawsuitCountTypeFilter;